import { useHtmlElementFromTemplateRef } from '@/composition/useHtmlElementFromTemplateRef'
import type { Ref } from '@/composition/vue/compositionApi'
import type { AnyTemplateElement } from '@/components/types'
import { useResizeObserver } from '@/composition/resizeObserver'
import { computed, ref } from '@/composition/vue/compositionApi'

type WidgetChatViewSizeObserverParams = {
  viewRef: Ref<AnyTemplateElement | null>
  viewScrollContainerRef: Ref<AnyTemplateElement | null>
  viewScrolledContentRef: Ref<AnyTemplateElement | null>
}

export const useWidgetChatViewSizeObserver = ({
  viewRef,
  viewScrollContainerRef,
  viewScrolledContentRef,
}: WidgetChatViewSizeObserverParams) => {
  const viewElementRef = useHtmlElementFromTemplateRef(viewRef)
  const viewScrollContainerElementRef = useHtmlElementFromTemplateRef(viewScrollContainerRef)
  const viewScrolledContentElementRef = useHtmlElementFromTemplateRef(viewScrolledContentRef)

  const viewHeight = ref(0)
  useResizeObserver(viewElementRef, (entries) => {
    const target = entries[0].target as HTMLElement
    viewHeight.value = target.offsetHeight
  })

  const viewScrollContainerHeight = ref(0)
  useResizeObserver(viewScrollContainerElementRef, (entries) => {
    const target = entries[0].target as HTMLElement
    viewScrollContainerHeight.value = target.offsetHeight
  })

  const viewScrolledContentHeight = ref(0)
  useResizeObserver(viewScrolledContentElementRef, (entries) => {
    const target = entries[0].target as HTMLElement
    viewScrolledContentHeight.value = target.offsetHeight
  })

  const height = computed(() => {
    return viewHeight.value - viewScrollContainerHeight.value + viewScrolledContentHeight.value
  })

  return {
    height,
  }
}
